import { IButtonStyles } from '@fluentui/react/lib/Button';
import { getPalette } from 'owa-theme';
import { FontWeights } from '@uifabric/styling';
export function getFilterButtonStyles(): IButtonStyles {
    const palette = getPalette();

    return {
        root: {
            border: '1px solid ' + palette.neutralQuaternaryAlt,
            padding: '0 4px',
            marginRight: '12px',
            borderRadius: '15px',
            minWidth: '0px',
            color: palette.neutralSecondary,
        },
        rootCheckedHovered: {
            border: '1px solid ' + palette.themeDarkAlt,
            color: palette.themeDarkAlt,
            backgroundColor: palette.themeLighterAlt,
        },
        rootHovered: {
            border: '1px solid ' + palette.neutralDark,
            backgroundColor: palette.neutralLighter,
            color: palette.neutralPrimary,
        },
        rootChecked: {
            border: '1px solid ' + palette.themeDarkAlt,
            color: palette.themeDarkAlt,
            backgroundColor: palette.white,
        },
        rootCheckedPressed: {
            border: '1px solid ' + palette.themeDarkAlt,
            color: palette.themeDarkAlt,
            backgroundColor: palette.themeLighter,
        },
        label: {
            fontWeight: FontWeights.regular,
        },
    };
}

export function getAdvancedSearchButtonStyles(): IButtonStyles {
    const palette = getPalette();

    return {
        root: {
            color: palette.themePrimary,
            padding: '0px',
            left: '-4px', // Move advanced search left to account for fluent button padding while maintaining 12px distance to leftmost filter
        },
    };
}
